import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import API from "../services/api";
import DesignerCanvas from "../components/designer/DesignerCanvas";

const RuntimePage = () => {
    const {id} = useParams();

    const [page, setPage] = useState(null);
    const [objects, setObjects] = useState([]);
    const [latestTags, setLatestTags] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const fetchRuntimeData = async () => {
        try {
            setLoading(true);
            setError("");

            const pageRes = await API.get(`/designer/pages/${id}/`);
            setPage(pageRes.data);

            const objectsRes = await API.get(`/designer/pages/${id}/objects/`);
            setObjects(objectsRes.data?.objects || []);
        } catch (err) {
            console.error("Runtime page load failed:", err);
            setError("Failed to load runtime page.");
        } finally {
            setLoading(false);
        }
    };

    const fetchLatestTags = async () => {
        try {
            const res = await API.get("/latest-tag-values/");
            setLatestTags(res.data || []);
        } catch (err) {
            console.error("Failed to fetch latest tags:", err);
        }
    };

    const handleRuntimeAction = async (targetObject) => {
        const data = targetObject?.data_json || {};

        console.log("Runtime action target:", targetObject);
        console.log("Runtime action data_json:", data);

        // -------------------------------------------------
        // TAG OBJECT CONTROL
        // -------------------------------------------------
        if (targetObject?.type === "tag" && (data.object_mode || "monitor") === "control") {
            const tagName =
                data.tag_name ||
                data.tag ||
                data.real_tag_name ||
                "";

            const controlType =
                targetObject.__controlType ||
                data.control_type ||
                "digital";

            const writeValue =
                targetObject.__controlValue !== undefined
                    ? targetObject.__controlValue
                    : data.write_value;

            if (!tagName) {
                alert("No real tag selected for this tag control.");
                console.warn("Tag control has no tag_name:", targetObject);
                return;
            }

            if (writeValue === "" || writeValue === null || writeValue === undefined) {
                alert("Please enter a value.");
                console.warn("Tag control has empty write value:", targetObject);
                return;
            }

            try {
                console.log("Runtime tag control write:", {
                    tag_name: tagName,
                    value: writeValue,
                    control_type: controlType,
                });

                const res = await API.post("/write-tag/", {
                    tag_name: tagName,
                    value: writeValue,
                    control_type: controlType,
                });

                console.log("Runtime tag control response:", res.data);
                await fetchLatestTags();
            } catch (err) {
                console.error("Failed to write tag from runtime tag control:", err);
                console.error("Server response:", err?.response?.data);
                alert(
                    "Failed to write tag.\n" +
                    JSON.stringify(err?.response?.data || err.message)
                );
            }
            return;
        }

        // -------------------------------------------------
        // BUTTON ACTIONS
        // -------------------------------------------------
        const actionType = data.action_type || data.action || "";

        if (actionType === "tag_write" || actionType === "set_tag") {
            const tagName =
                data.tag_name ||
                data.tag ||
                data.real_tag_name ||
                "";

            const writeValue =
                data.write_value !== undefined
                    ? data.write_value
                    : data.value !== undefined
                        ? data.value
                        : 1;

            const controlType = data.control_type || "digital";

            if (!tagName) {
                alert("No real tag selected for this button.");
                console.warn("Button has no tag_name:", targetObject);
                return;
            }

            try {
                console.log("Runtime button tag write:", {
                    tag_name: tagName,
                    value: writeValue,
                    control_type: controlType,
                });

                const res = await API.post("/write-tag/", {
                    tag_name: tagName,
                    value: writeValue,
                    control_type: controlType,
                });

                console.log("Write tag response:", res.data);
                await fetchLatestTags();
            } catch (err) {
                console.error("Failed to write tag from runtime button:", err);
                console.error("Server response:", err?.response?.data);
                alert(
                    "Failed to write tag.\n" +
                    JSON.stringify(err?.response?.data || err.message)
                );
            }
            return;
        }

        if (actionType === "link" || actionType === "navigate") {
            const url = data.url || data.link || "";
            const openInNewTab = data.open_in_new_tab ?? true;

            if (!url) {
                alert("No URL configured.");
                console.warn("Button has no URL:", targetObject);
                return;
            }

            console.log("Opening URL:", url);

            if (openInNewTab) {
                window.open(url, "_blank", "noopener,noreferrer");
            } else {
                window.location.href = url;
            }
            return;
        }

        alert("This object has no valid action configured.");
        console.warn("Unknown runtime action:", targetObject);
    };

    useEffect(() => {
        fetchRuntimeData();
        fetchLatestTags();

        const interval = setInterval(fetchLatestTags, 3000);
        return () => clearInterval(interval);
    }, [id]);

    if (loading) {
        return <div style={{padding: 20}}>Loading...</div>;
    }

    if (error || !page) {
        return (
            <div style={{padding: 20, color: "red"}}>
                {error || "Page not found."}
            </div>
        );
    }

    return (
        <div
            style={{
                width: "100vw",
                height: "100vh",
                overflow: "auto",
                background: page.background_color || "#ffffff",
            }}
        >
            <DesignerCanvas
                page={page}
                objects={objects}
                latestTags={latestTags}
                selectedObjectId={null}
                setSelectedObjectId={() => {
                }}
                updateObjectPosition={() => {
                }}
                updateObjectRect={() => {
                }}
                updateObjectDataField={() => {
                }}
                onButtonAction={handleRuntimeAction}
                readOnly={true}
                hideCanvasPadding={true}
            />
        </div>
    );
};

export default RuntimePage;